import "core-js/modules/es7.array.includes.js";
import '@web/shared-digital-library/icons/svg-originals/download.svg';
import '@web/shared-digital-library/icons/svg-originals/sav.svg';
import { SELF_TARGET } from '~/const/button';
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
var SIZES = {
  S: 'btn-sm',
  M: '',
  L: 'btn-lg'
};
var TYPES = {
  primary: 'btn-dark',
  secondary: '',
  transparent: 'btn-transparent'
};
export default {
  name: 'Cta',
  components: {
    MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    svg: {
      type: String,
      default: ''
    },
    textBtn: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'transparent'].includes(value);
      }
    },
    url: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'M'
    }
  },
  computed: {
    hasTextButton() {
      if (this.textBtn.length <= 0) {
        return false;
      }
      return true;
    },
    sizes() {
      return SIZES;
    },
    targetAttribute() {
      return this.target === '' ? null : SELF_TARGET;
    },
    types() {
      return TYPES;
    }
  }
};